import { CommunicationNetworkGraphNodeKindEnum } from '@workalizer/shared/types';
export { CommunicationNetworkGraphNodeKindEnum as CommunicationChartNodeKindEnum };
var NON_PERSON_NODE_KINDS = new Set([
    CommunicationNetworkGraphNodeKindEnum.External,
    CommunicationNetworkGraphNodeKindEnum.CrossTeamAggregate,
    CommunicationNetworkGraphNodeKindEnum.Other,
    CommunicationNetworkGraphNodeKindEnum.InternalMeet,
    CommunicationNetworkGraphNodeKindEnum.CrossTeamSpaceChat,
    CommunicationNetworkGraphNodeKindEnum.ExternalSpaceChat
]);
var SYNTHETIC_NODE_KINDS = NON_PERSON_NODE_KINDS;
var NON_ORG_TEAM_NODE_KINDS = new Set([
    CommunicationNetworkGraphNodeKindEnum.External,
    CommunicationNetworkGraphNodeKindEnum.CrossTeamAggregate,
    CommunicationNetworkGraphNodeKindEnum.Other,
    CommunicationNetworkGraphNodeKindEnum.InternalMeet,
    CommunicationNetworkGraphNodeKindEnum.CrossTeamSpaceChat,
    CommunicationNetworkGraphNodeKindEnum.ExternalSpaceChat,
    CommunicationNetworkGraphNodeKindEnum.CrossTeam
]);
export var isCommunicationChartCrossTeamNodeKind = function (kind) {
    return kind === CommunicationNetworkGraphNodeKindEnum.CrossTeam;
};
export var isCommunicationChartExternalNodeKind = function (kind) {
    return kind === CommunicationNetworkGraphNodeKindEnum.External ||
        kind === CommunicationNetworkGraphNodeKindEnum.ExternalSpaceChat;
};
export var isCommunicationChartHubNodeKind = function (kind) {
    return kind === CommunicationNetworkGraphNodeKindEnum.InternalMeet ||
        kind === CommunicationNetworkGraphNodeKindEnum.CrossTeamSpaceChat ||
        kind === CommunicationNetworkGraphNodeKindEnum.ExternalSpaceChat;
};
export var isCommunicationChartSyntheticNodeKind = function (kind) {
    return kind !== undefined && SYNTHETIC_NODE_KINDS.has(kind);
};
export var isCommunicationChartPersonNodeKind = function (kind) { return kind === undefined || !NON_PERSON_NODE_KINDS.has(kind); };
export var isCommunicationChartTeamMemberNodeKind = function (kind) {
    return isCommunicationChartPersonNodeKind(kind) &&
        !isCommunicationChartCrossTeamNodeKind(kind);
};
export var isCommunicationChartOrgTeamNodeKind = function (kind) { return kind === undefined || !NON_ORG_TEAM_NODE_KINDS.has(kind); };
export var isCommunicationChartPersonNode = function (node) { return isCommunicationChartPersonNodeKind(node.kind); };
export var isCommunicationChartTeamMemberNode = function (node) { return isCommunicationChartTeamMemberNodeKind(node.kind); };
export var resolveCommunicationChartInspectorNodeRole = function (node) {
    if (isCommunicationChartCrossTeamNodeKind(node.kind)) {
        return 'otherTeam';
    }
    if (isCommunicationChartExternalNodeKind(node.kind)) {
        return 'external';
    }
    return 'teammate';
};
